<style lang="scss" scoped>
.content-wrapper {
  display: flex;
  height: 100%;
  position: relative;
}

.dialog-message-input-wrapper {
  display: flex;
  align-items: center;
  width: 100%;
}

.dialog-loading {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.3);
  font-size: 50px;
  z-index: 1;
  color: #fff;
}

.dialog-message-support {
  height: auto;
  background-color: #e9ecef;
  border-radius: 0;
}

.dialog-message-input {
  min-width: 0;
  flex-grow: 0;
  border-radius: 15px;
  margin: 8px 5px;
  height: 32px;

  &::placeholder {
    color: #c5c5c5;
  }
}

.dialog-message-characters {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  color: #b3aeb4;
  padding: 0.375rem 0.75rem;
  white-space: nowrap;
}

.dialog-message-submit {
  flex-grow: 1;
  margin: 6px 5px;
  border-radius: 8px;
  padding: 5px;
}

.dialog-inputs {
  background-color: #f2f2f2;
}

@media (max-width: 1200px) {
  .dialog-inputs {
    flex-wrap: wrap;
  }
}

@media (max-width: 480px) {
  .dialog-message-input-wrapper {
    flex-wrap: wrap;
  }
  .dialog-message-input {
    width: 100%;
  }
  .dialog-message-characters {
    width: 50%;
    margin: 0;
    font-size: 70%;
  }
  .dialog-message-submit {
    width: 50%;
    white-space: normal;
    margin: 0;
    font-size: 70%;
  }
}
</style>
<template>
  <div class="content-wrapper flex-column justify-content-between">
    <div v-if="showLoading" class="dialog-loading">
      <i class="fas fa-spinner fa-pulse"></i>
    </div>
    <dialog-scroller
      :idPartner="idPartner"
      :profile="profile"
      :support="support"
      @loading="loading = arguments[0]"
    ></dialog-scroller>
    <section v-show="!support && !hideInputs">
      <form
        @submit.prevent="sendTextMessage"
        action
        class="d-flex dialog-inputs"
      >
        <div class="col">
          <div class="row">
            <dialog-text-area
              ref="messageInput"
              @keyup="keyUp"
              :onEnter="sendTextMessage"
              @click="setLastCursorPosition"
              type="text"
              class="form-control dialog-message-input"
              v-model="message"
              placeholder="Schreibe eine Nachricht"
            >
            </dialog-text-area>
          </div>
          <div class="row">
            <chat-input-buttons
              @add-emoji="addEmoji"
              @send-blink="persistMessage(3, null)"
              @send-gif="sendGif"
              @send-gift="sendGift"
              @send-image="sendImage"
              :enableSending="messageSent"
              :customer="true"
            ></chat-input-buttons>
            <div class="dialog-message-input-wrapper">
              <div class="dialog-message-characters">
                <span
                  >{{ messageLength }} | {{ charsToNextMessage }} Zeichen</span
                >
              </div>
              <button
                type="submit"
                :disabled="!canSendMessage"
                class="dialog-message-submit btn btn-primary"
              >
                Senden |
                <small>{{ messagePriceText }}</small>
              </button>
            </div>
          </div>
        </div>
      </form>
    </section>
    <div v-show="support">
      <div class="form-control dialog-message-support">
        Du kannst dem Support Team antworten, in dem du das Kundensupport
        Formular nutzt.
      </div>
    </div>
  </div>
</template>
<script lang="babel">
import DialogScroller from "@/components/DialogScroller.vue";
import DialogTextArea from '@/components/DialogTextArea.vue';
import ChatInputButtons from '@/components/Customer/chat/ChatInputButtons.vue';

import UploadModal from "@/components/UploadModal.vue";


export default {
  components: {
    DialogScroller,
    DialogTextArea,
    ChatInputButtons,
    UploadModal
  },
  props: {
    idPartner: {
      required: true,
    },
    profile: {
      type: Object,
      require: true,
    },
    support: {
      type: Boolean,
      required: true,
    },
    hideInputs: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      message: localStorage.getItem('partner-id_' + this.idPartner) || "",
      lastCursorPosition: 0,
      loading: false,
      messageSent: true,
      firstContact: false,
    };
  },
  computed: {
    messageLength () {
      return this.message.length;
    },
    charsToNextMessage() {
      if (this.messageCount === 0) {
        return 300;
      }
      return (300 * this.messageCount);
    },
    messageCount() {
      return Math.ceil(this.message.length / 300);
    },
    currency() {
      return Laravel.lang.currency;
    },
    pricePerMessage(){
      return Laravel.settings.pricePerMessage;
    },
    totalPrice() {
      return this.pricePerMessage * this.messageCount;
    },
    messagePriceText() {
      if (! this.firstContact || this.firstMessagePrice == this.messagePrice) {
        return `${this.totalPrice} ${this.currency}`;
      }
      if (this.firstMessagePrice > 0 && this.firstMessagePrice < this.messagePrice) {
        return `Nachrichten bei Erstkontakt sind günstiger | ${this.firstMessagePrice} ${this.currency}`
      }
      return `Nachrichten bei Erstkontakt sind kostenlos`;
    },
    messagePrice() {
      return Laravel.settings.pricePerMessage;
    },
    firstMessagePrice() {
      return Laravel.settings.firstMessagePrice;
    },
    showLoading() {
      return this.loading && !this.support && this.$store.getters["message/dialog"](this.idPartner, this.profile.id).length === 0;
    },
    canSendMessage() {
      return this.message.trim().length > 0
        && this.messageSent;
    },
  },
  methods: {
    keyUp(event) {
      this.setLastCursorPosition(event);
      this.saveMessageLocal();
    },
    setLastCursorPosition(event) {
      this.lastCursorPosition = event.target.selectionStart;
    },
    saveMessageLocal () {
      localStorage.setItem('partner-id_' + this.idPartner, this.message);
    },
    addEmoji(e) {
      if (this.lastCursorPosition > this.message.length) {
        this.lastCursorPosition = 0;
      }
      this.message = this.message.substr(0,this.lastCursorPosition) + e.colons + this.message.substr(this.lastCursorPosition);
      this.$refs.messageInput.$el.focus();
      this.saveMessageLocal();
    },
    persistMessage(type = null, meta = null) {
      if (type === null && !this.canSendMessage) {
        return;
      }
      this.messageSent = false;
      let data = null;
      if (type != 4 ) {
        data = {
          body: type===null ? this.message: ' ',
          receiver_id: this.idPartner,
          sender_id: this.profile.id,
          type,
          meta,
        }
      }
      else {
        data = new FormData();
        data.append("meta", meta[0], meta[1]);
        data.append("body", " ");
        data.append("receiver_id", this.idPartner);
        data.append("sender_id", this.profile.id);
        data.append("type", 4);
      }

      this.$store.dispatch('message/create', {
          url: "/api/v1/message", data
        }).then(() => {
          this.message = "";
          this.$emit('message-sent');
        }).finally(() => {
          this.messageSent = true;
          this.firstContact = false;
        })
        .catch(error => {
          this.$notify({
            title: error.response.data.message,
            type: "error"
          });
        });
      localStorage.removeItem('partner-id_' + this.idPartner);
    },
    sendTextMessage() {
      if(this.canSendMessage) {
        this.persistMessage();
      }
    },
    sendGif(url) {
      this.persistMessage(1, {
        url,
      });
    },
    sendGift(giftId) {
      this.persistMessage(2, {
        giftId,
      });
    },
    sendImage(event) {
      this.persistMessage(4,
        [event.target.files[0], event.target.files[0].name],
      );
    },
    getFirstContact() {
      this.$http.get('/api/v1/customerProfile/firstContact', {
          params: {
            customerProfileId: this.idPartner,
          }
        })
        .then(({data}) => {
          this.firstContact = data;
        })
    }
  },
  mounted() {
    this.$refs.messageInput.$el.focus();
    this.getFirstContact();
  },
  watch: {
    idPartner() {
      this.getFirstContact();
    }
  }
}
</script>
